export enum RegistrationRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  REGISTERED = "REGISTERED",
}
